<style lang="scss">

</style>

<!-- eslint-disable -->
<template>
  <section class="text-center">
    <h3>Are you sure you want to block {{contact.firstname}} {{contact.lastname}}?</h3>

    <section class="mt-2">
      <b-form-textarea v-model="reason" placeholder="enter a reason for blocking" max-rows="3"></b-form-textarea>
    </section>

    <section class="d-inline-flex full-width mt-2">
      <div class="ui-spacer"></div>
      <b-button class="mr-2" @click="$emit('close', true)">Cancel</b-button>
      <b-button :class="{'disabled': loading}" variant="success" @click="blockContact()">Block Contact</b-button>
    </section>
  </section>
</template>
<!-- eslint-enable -->

<script>
import ContactService from '@/services/ContactService'

export default {
  components: {},
  props: {
    contact: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      reason: '',
      loading: false,
    }
  },
  mounted() {},
  methods: {
    blockContact() {
      this.loading = true;
      ContactService.blockContact(this.contact.user_id, this.reason).then(() => {
        this.$toast.success(`Blocked contact: ${this.contact.firstname} ${this.contact.lastname} Successfully`, {
          toastClassName: ['toast-std', 'success-toast'],
        });
      }).catch(() => {
        this.$toast.error('Could not block contact, please refresh and try again', {
          toastClassName: ['toast-std', 'warning-toast'],
        });
      }).finally(() => {
        this.loading = false;
        this.$emit('ok', true);
      })
    },
  },
}
</script>
